import React from 'react';
import { StylonCharacter } from './StylonCharacter';

/**
 * LUNA — the white member of the Stylon team, alive (StylonCharacter kind "ai"), as the portal's LunaCharacter
 * (round 3, owner 10-23: "match Luna in the portal"). The launcher, the glass top bar, the empty state and the
 * thinking row are all this one. `loading` / `speaking` / `listening` / `typing` / `typingProgress` / `interactive`
 * pass through; the direction comes from the chat (its eyes follow the cursor the way the text runs).
 */
export function LunaCharacter({ size = 44, kind = 'ai', interactive = false, ...rest }) {
  return <StylonCharacter kind={kind} size={size} interactive={interactive} testId="luna-character" {...rest} />;
}

export default LunaCharacter;
